import { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";
import type { FlexFormFirestoreSelectOptionSet } from "@captiva/shared-types";

export type OptionsSetToDuplicate = Partial<FlexFormFirestoreSelectOptionSet> & { id?: string };

export interface UseDuplicateOptionsSetResult {
  duplicateOptionsSet: (optionsSet: OptionsSetToDuplicate) => Promise<string>;
  duplicating: boolean;
  error: string | null;
}

export function useDuplicateOptionsSet(companyId: string): UseDuplicateOptionsSetResult {
  const [duplicating, setDuplicating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const duplicateOptionsSet = async (optionsSet: OptionsSetToDuplicate): Promise<string> => {
    setDuplicating(true);
    setError(null);
    try {
      const duplicatedOptionsSet = {
        ...optionsSet,
        companyId,
        name: `${optionsSet.name || ""} (copy)`,
      };
      delete duplicatedOptionsSet.id; // Let Firestore generate new ID

      const docRef = await addDoc(collection(db, "flexFormSelectOptions"), duplicatedOptionsSet);
      return docRef.id;
    } catch (err: any) {
      setError(err.message || "Error duplicating options set");
      throw err;
    } finally {
      setDuplicating(false);
    }
  };

  return {
    duplicateOptionsSet,
    duplicating,
    error,
  };
}